import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ButtonIconComponent} from '../../../../../../../shared/components/button-icon/button-icon.component';
import {InputTextComponent} from '../../../../../../../shared/components/input-text/input-text.component';
import {TranslateSafePipe} from '../../../../../../../shared/pipes/translation.pipe';
import {AlarmRuleConditionOfflineConfig,} from '../../../../../../../types/dtos/alarm-rule-condition.dto';
import {InputTextInterface} from '../../../../../../../types/interfaces/input.interface';
import {BaseCondition} from '../base-condition';
import {BaseRuleCondition} from '../base-rule-condition';
import {LastActivityRuleCondition} from './last-activity.rule-condition';

@Component({
  selector: 'app-last-activity-condition',
  imports: [
    InputTextComponent,
    ButtonIconComponent,
    TranslateSafePipe,
  ],
  templateUrl: './last-activity-condition.html',
  styleUrls: [
    './last-activity-condition.css',
    '../base-rule-condition.css'
  ]
})
export class LastActivityCondition extends BaseCondition {
  override ruleCondition: BaseRuleCondition = new LastActivityRuleCondition();

  constructor(
    private readonly _translateService: TranslateService
  ) {
    super();
  }

  public get getDefaultValueString(): string {
    const config = this.getConfig() as unknown as AlarmRuleConditionOfflineConfig | undefined;

    const hourText: string = this._translateService.instant(
      'common.input.hour.label'
    );

    return config?.hour + ' ' + hourText;
  }

  public getLastActivityHourInput(): InputTextInterface {
    return {
      formGroup: this.formGroup,
      isTranslated: true,
      label: 'common.input.hour.label',
      type: 'number',
      required: true,
      id: 'hour'
    };
  }
}
